import { useState } from "react";

export default function AccordionItem({
  id,
  question,
  answer,
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = `faq-panel-${id}`;
  const btnId = `faq-btn-${id}`;

  return (
    <div
      className={`rounded-xl border transition-all duration-300 ${
        open
          ? "border-primary-200 shadow-md bg-white"
          : "border-gray-200 bg-white/90 hover:shadow-sm"
      }`}
    >
      {/* Header button */}
      <button
        id={btnId}
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-4 p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 rounded-xl"
        aria-expanded={open}
        aria-controls={panelId}
      >
        <div className="flex items-start gap-3">
          {/* Dot/icon */}
          <span
            className={`mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
              open
                ? "bg-primary-100 text-primary-600"
                : "bg-gray-100 text-gray-500"
            }`}
          >
            ?
          </span>

          <span className="text-base sm:text-lg font-semibold text-gray-900">
            {question}
          </span>
        </div>

        {/* Chevron */}
        <span
          className={`inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-50 text-gray-500 transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
          aria-hidden="true"
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </span>
      </button>

      {/* Animated body: grid rows trick for smooth auto-height */}
      <div
        id={panelId}
        role="region"
        aria-labelledby={btnId}
        className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <div className="px-5 pb-5 pt-1">
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              {answer}
            </p>
          </div>
        </div>
      </div>

      {/* Accent bar when open */}
      <div
        className={`h-1 rounded-b-xl transition-colors ${
          open ? "bg-primary-100" : "bg-transparent"
        }`}
      />
    </div>
  );
}
